// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faqs_faqs__MyyAp","heading":"faqs_heading__W1pIb","list":"faqs_list__2M1jP","question":"faqs_question__1GejE","answer":"faqs_answer__3-Df5","divider":"faqs_divider__2076D"};